import staticRouteHandlers from './static-route-handlers';

function getHandler(path) {
  // eslint-disable-next-line no-restricted-syntax,no-unused-vars,guard-for-in
  for (const [staticRoutePattern, staticRouteHandler] of staticRouteHandlers.entries()) {
    if (staticRoutePattern.test(path)) return staticRouteHandler;
  }
  return false;
}

export default {
  getHandler
};
